import React, { useState } from 'react';
import { actions, elements, inputs, overlays } from '@ecosystem/newron-design-system';
import { FeedbackCategory } from './helper';
import { RadioOption } from '@ecosystem/newron-design-system/build/components/radioButtons/RadioButtons';
import { capitalize } from 'lodash';

const { Modal } = overlays;
const { Button } = actions;
const { RadioButtons, TextInput } = inputs;
const { TruncateText } = elements;

interface FeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  handleApply: (feedbackCategory: FeedbackCategory, comment?: string) => void;
}

const feedbackCategoryOptions: RadioOption[] = Object.values(FeedbackCategory).map(category => ({
  label: capitalize(category),
  value: category,
}));

export const FeedbackModal: React.FC<FeedbackModalProps> = ({ handleApply, isOpen, onClose }) => {
  const [feedbackCategory, setFeedbackCategory] = useState<string>(FeedbackCategory.INACCURATE);
  const [comment, setComment] = useState<string | undefined>();

  return (
    <Modal size="lg" isOpen={isOpen} onClose={onClose} renderInPortal>
      <Modal.Header>Help us improve</Modal.Header>
      <Modal.Body>
        <div className="flex flex-column gap-2">
          <div>
            <TruncateText
              className="text-md font-bold py-1 w-auto text-heading"
              text="Provide additional feedback below, select one option"
              type={TruncateText.Type.LABEL}
            />
            <RadioButtons options={feedbackCategoryOptions} onChange={setFeedbackCategory} value={feedbackCategory} />
          </div>
          <TextInput
            maxLength={150}
            label="How can the response be improved?"
            placeholder="Please describe your feedback here"
            onChange={setComment}
            value={comment}
            testId="feedback-comment"
          />
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button mode="secondary" onClick={onClose} testId="feedback-cancel-btn">
          Cancel
        </Button>
        <Button onClick={() => handleApply(feedbackCategory as FeedbackCategory, comment)} testId="feedback-submit-btn">
          Submit feedback
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
